import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepsData } from './stepsData';

const routes: Routes = [
  {
    path: 'steps',
    component: StepsData,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StepsDataRoutingModule {}
